<section>
  <h2>User Preferences</h2>
  <ness-filter-preferences></ness-filter-preferences>
</section>
